import React from "react";

export default function SettingsCard({ title, badge, children }) {
  return (
    <div className="bg-white border border-blue-100 rounded-2xl flex flex-col overflow-hidden shadow-[0_10px_30px_rgba(15,23,42,0.05)]">
      <div
        className="px-6 py-4 border-b border-blue-100 rounded-t-2xl"
        style={{ background: "linear-gradient(135deg, #ffffff 0%, #eff6ff 100%)" }}
      >
        <div className="flex items-center justify-between gap-3">
          <p className="font-inter font-semibold text-sm text-gray-700 uppercase tracking-wider">
            {title}
          </p>
          {badge || null}
        </div>
      </div>
      {children}
    </div>
  );
}
